"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.constrainValue = void 0;
const constrainValue = (min, max, val) => {
  let returnVal = val;
  if (returnVal > max) {
    returnVal = max;
  } else if (returnVal < min) {
    returnVal = min;
  }
  return returnVal;
};
exports.constrainValue = constrainValue;
//# sourceMappingURL=constrainValue.js.map